export default "__VITE_ASSET__BkG1cKFf__"